module.exports = __webpack_public_path__ + "static/img/yujiao_03.4f375e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/yujiao_03.png
// module id = HNR7
// module chunks = 0